
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.458 5.407c-.133.21-.046.481.166.612l8.85 5.479a1 1 0 001.052 0l8.85-5.479c.212-.13.299-.401.166-.612A2.998 2.998 0 0019 4H5a2.998 2.998 0 00-2.542 1.407z"}}),_c('path',{attrs:{"d":"M22 8.883a.5.5 0 00-.763-.425l-7.658 4.74a3 3 0 01-3.158 0l-7.658-4.74A.5.5 0 002 8.883V17a3 3 0 003 3h14a3 3 0 003-3V8.883z"}})])
          )
        }
      }
    